import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/checkstatus', request)
}

export {get}
